import { FC, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion } from 'react-bootstrap';
import { useNavigationData } from '../../modules/NavigationProvider';
import EmailForm from './components/EmailForm';
import PasswordForm from './components/PasswordForm';

const SecurityPage: FC = () => {
  const { t } = useTranslation('security');
  const { setPath, setButtonText, setHeaderText } = useNavigationData();

  useLayoutEffect(() => {
    setPath('/menu');
    setButtonText(t('home'));
    setHeaderText(t('title'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center h-100 mt-5">
      <Accordion defaultActiveKey="0" style={{ minWidth: '300px' }}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span className="text-uppercase">{t('accordion.email')}</span>
          </Accordion.Header>
          <Accordion.Body>
            <EmailForm />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <span className="text-uppercase">{t('accordion.password')}</span>
          </Accordion.Header>
          <Accordion.Body>
            <PasswordForm />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default SecurityPage;
